module.exports = __webpack_public_path__ + "static/eric-resendiz-3-699bbfb0f80bdcc8e6ddc6c0432ac0fd.jpg";